/**
 * adminMockData — the parts of the Administration tab still backed by static
 * data rather than an API response.
 *
 * SECURITY_RIGHTS defines the fixed set of togglable rights themselves (User
 * Management reads per-user values from gaussiq-identity, see src/api/security.js,
 * but the catalog of rights that exist is a frontend constant, not API data).
 * DEFAULT_SKILL_SETTINGS is only the initial-render placeholder AdminSkillsTab
 * shows before its real fetch from gaussiq-admin resolves.
 */

export const SECURITY_RIGHTS = [
  {
    key: 'admin',
    label: 'Admin',
    description: 'Manage users, security rights and workspace settings.',
    tone: 'blue',
  },
  {
    key: 'orgSkillManagement',
    label: 'Org Skill Management',
    description: 'Assign, approve, reject, lock, and remove skills across the whole organisation.',
    tone: 'green',
  },
  {
    key: 'teamSkillManagement',
    label: 'Team Skill Management',
    description: 'Assign, approve, reject, lock, and remove skills within their own team only.',
    tone: 'blue',
  },
]

export const DEFAULT_SKILL_SETTINGS = {
  orgSkillTemperature: 0.6,
  individualEvidenceThreshold: 70,
  autoApproveOrgSkills: false,
  autoApproveIndividualSkills: true,
  maxTicketAssignment: 12,
}
